import getHtmlParam from '../../utilities/htmlParam';
import { HtmlEscapeUtils } from "../../utilities/HtmlEscapeUtils"
import * as traversal from '../../utilities/traversal';
import { domReady, windowLoaded } from '../../utilities/domready';
import { getPrice } from './price';
import { resetFields, updatePriceListName, enableButton, updateInc } from './helper';
import { resizeGallery } from './gallery';
import { SimilarProducts } from './similar-products';
import { shipmentTooltip, installationTooltip } from './tooltip';
import { updateAccessory } from './accessory';
import { OrderedTogether } from './orderedTogether';
import { getReminder, setupTooltip } from "./reminder";
import { addEnterAndSpaceHandler } from "@utils/accessibility/general";

export class Toggle {

    mp = getHtmlParam('.js-mp .param');
    param = getHtmlParam('.js-param .param');
    selectedItem = this.param.get('selectedItem');

    stateChange = 0;
    selectedSlide = '';
    selectedImage = '';
    currentImage = '';
    slideIndex = false;
    newPrice = '';
    maxHeight: number = 130;

    soldOut = document.getElementById('sold_out');
    soldOutMsg = document.getElementById('sold-out-msg');
    not_Available = document.getElementById('not_available');
    notAvailableMsg = document.getElementById('not-available-msg');
    available = document.getElementById('available');
    quantity = document.getElementById('quantity');
    basketEnabled = document.getElementById('basket-enabled');
    basketDisabled = document.getElementById('basket-disabled');
    basketReminder = document.getElementById('basket-reminder');
    stickyBasketCta = document.getElementById('sticky-basket-cta');
    stickyBasketCtaBox = document.querySelector('.pda-sticky-cta-box');
    articleTitle = document.getElementById('article-title');
    articlePrice = document.getElementById('article-price');
    featureToggles = document.querySelectorAll('.pda-cta-toggle .feature-toggle');
    pdaCtaButtons = document.querySelector('.pda-cta-buttons');

    private dropdownToggle() {

        if (typeof this.featureToggles !== 'undefined') {
            this.featureToggles.forEach((feature: HTMLElement) => {
                const height: number = feature.clientHeight;

                if (height > this.maxHeight) {

                    domReady(() => {
                        const toggles = feature.querySelectorAll('.feature-toggle-value');
                        const featureId = feature.getAttribute('data-feature-id');
                        const featureLabel = feature.getAttribute('data-feature-label');

                        let selectBox = document.createElement('select');
                        selectBox.id = 'variant-filter-' + featureId;
                        selectBox.className = 'variant-filter-select';
                        selectBox.setAttribute('data-feature-id', featureId);
                        selectBox.setAttribute('data-dtm-pda-dropdown', 'true');
                        selectBox.setAttribute('aria-label', featureLabel);

                        let option = document.createElement('option');
                        option.value = '';
                        option.text = featureLabel;
                        option.disabled = true;
                        selectBox.appendChild(option);

                        if (typeof toggles !== 'undefined') {
                            toggles.forEach((toggle: HTMLElement) => {
                                const featureValues = toggle.querySelectorAll('.js-feature-toggle-value');

                                toggle.classList.add('hidden');

                                option = document.createElement('option');
                                option.value = toggle.getAttribute('data-value');

                                if(toggle.classList.contains('feature-toggle-color')) {
                                    option.text = toggle.getAttribute('data-value');
                                } else {
                                    option.text = toggle.textContent;
                                }

                                if(toggle.classList.contains('feature-toggle-active')) {
                                    option.selected = true;
                                    option.setAttribute ('selected', 'selected');
                                    option.className = '_selected';
                                }

                                selectBox.appendChild(option);
                            });
                        }

                        feature.appendChild(selectBox);

                        selectBox.addEventListener('change', () => {
                            this.processingUpdate(selectBox, 'select');
                        });

                    });
                }
            });
        }
    }

    private initToggleListener() {
        // show tooltip for disabled toggle
        const toggles = document.querySelectorAll('.js-feature-toggle-value');
        if (typeof toggles !== 'undefined') {
            toggles.forEach((toggle: HTMLElement) => {
                toggle.addEventListener('click', () => {
                    this.processingUpdate(toggle);
                });
            });
        }
    }

    processingUpdate(toggle: HTMLElement, type?: string, updateSelection?: string) {
        // prepare request parameter
        const $wrapper = traversal.parents(toggle, '.feature-toggle-wrapper')[0];
        const $featureToggles = $wrapper.querySelectorAll('.js-feature-toggle');
        const $productWrapper = traversal.parents(toggle, '.js-pues-list-productId')[0];
        let lastSelectedlabel = toggle.getAttribute('data-feature-label');

        let key = 0;
        let selectedFeatures: any = {};
        let selectedFeaturesById: any = {};
        let productId = '';

        if (typeof $productWrapper !== 'undefined' && $productWrapper) {
            productId = traversal.parents(toggle, '.js-pues-list-productId')[0].getAttribute('data-product-id');
        } else {
            productId = $wrapper.getAttribute('data-product-id');
        }

        // toggleType = 'toggle';

        const toggleError = $wrapper.querySelectorAll('.feature-toggle-error');
        if(typeof toggleError !== 'undefined') {
            toggleError.forEach((error: HTMLElement) => {
                error.parentNode.removeChild(error);
            });
        }

        // unset and set active class
        const toggleSiblings = traversal.siblings(toggle, '.js-feature-toggle-value');
        if(typeof toggleSiblings !== 'undefined') {
            toggleSiblings.forEach((sibling: HTMLElement) => {
                sibling.classList.remove('feature-toggle-active');
            });
        }

        if (type === 'select') {
            const value = (toggle as HTMLSelectElement).value;
            const featureId = toggle.getAttribute('data-feature-id');
            const dropDownDataValue = $wrapper.querySelector(`.js-feature-toggle-value[data-value="${CSS.escape(value)}"][data-feature-id="${CSS.escape(featureId)}"]`);
            dropDownDataValue && dropDownDataValue.classList.add('feature-toggle-active');
            lastSelectedlabel = toggle.parentElement.getAttribute('data-feature-label');
        } else {
            toggle.classList.add('feature-toggle-active');
        }

        if(typeof $featureToggles !== 'undefined') {
            $featureToggles.forEach((feature: HTMLElement) => {
                const toggles = feature.querySelectorAll('.js-feature-toggle-value');
                const label = feature.getAttribute('data-feature-label');
                const featureId = feature.getAttribute('data-feature-id');
                let hasActive = 0;

                if(typeof toggles !== 'undefined') {
                    toggles.forEach((toggle: HTMLElement) => {
                        const value = toggle.getAttribute('data-value');

                        if (toggle.classList.contains('feature-toggle-active')) {
                            hasActive = 1;
                            selectedFeatures[label] = value;
                            selectedFeaturesById[featureId] = encodeURI(value);
                        }
                    });
                }

                // add empty value if there is no matching
                if (hasActive === 0) {
                    selectedFeatures[label] = '';
                    selectedFeaturesById[featureId] = '';
                }
            });
        }

        const requestJson = {
            'lastSelectedFeatureName': lastSelectedlabel,
            'selectedFeatureValues': selectedFeatures
        };

        const xhr = new XMLHttpRequest();
        xhr.open('POST', this.param.get('urlPrefix') + '/product/feature/dropdown/' + productId);
        xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        xhr.send(JSON.stringify(requestJson));

        xhr.onreadystatechange = () => {
            const DONE = 4; // readyState 4 means the request is done.
            const OK = 200; // status 200 is a successful return.
            if (xhr.readyState === DONE) {
                if (xhr.status === OK) {

                    const response = JSON.parse(xhr.responseText);
                    if(typeof response !== 'undefined') {
                        for (let key in response) {
                            const disabled = response[key].disabledValues;
                            const hidden = response[key].hiddenValues;

                            const variantDropDown = document.getElementById('variant-filter-' + response[key].id) as HTMLSelectElement;
                            variantDropDown && (variantDropDown.value = response[key].selectedValue);

                            const featureToggleLabel = $wrapper.querySelector('#feature-' + response[key].id + ' .feature-toggle-label');

                            if (response[key].selectedValue == 'null') {
                                let errorText = $wrapper.querySelectorAll('.feature-toggle-error-text')[0].textContent;
                                let newcontent = document.createElement('span');
                                newcontent.className = 'feature-toggle-error';
                                newcontent.innerHTML = errorText;
                                featureToggleLabel && featureToggleLabel.appendChild(newcontent);
                            }

                            // remove active value
                            featureToggleLabel && (featureToggleLabel.querySelectorAll('span.feature-toggle-unit')[0].innerHTML = '');

                            // set values
                            const toggles = $wrapper.querySelectorAll('#feature-' + response[key].id + ' .js-feature-toggle-value');
                            if(typeof toggles !== 'undefined') {
                                toggles.forEach((toggle: HTMLElement) => {
                                    const value = toggle.getAttribute('data-value');
                                    const inArrayDisabled = disabled.indexOf(value);
                                    const inArrayHidden = hidden.indexOf(value);
                                    let unit = '';

                                    // set disabled values
                                    if (inArrayDisabled === -1) {
                                        toggle.classList.remove('feature-toggle-disabled');
                                    } else {
                                        toggle.classList.add('feature-toggle-disabled');
                                    }

                                    // set hidden values
                                    if (inArrayHidden === -1) {
                                        toggle.classList.remove('feature-toggle-hidden');
                                    } else {
                                        toggle.classList.add('feature-toggle-hidden');
                                    }

                                    // set active value
                                    if (value === response[key].selectedValue) {
                                        toggle.classList.add('feature-toggle-active');
                                        if (typeof response[key].unit !== 'undefined' && response[key].unit !== 'null' && response[key].unit !== null) {
                                            unit = response[key].unit;
                                        }
                                        const toggleLabelSibling = traversal.siblings(toggle, '.feature-toggle-label')[0];
                                        toggleLabelSibling && (toggleLabelSibling.querySelectorAll('span')[0].innerHTML = value + ' ' + unit);
                                    } else {
                                        toggle.classList.remove('feature-toggle-active');
                                    }
                                });
                            }
                        }
                    }

                    // get article from mapping
                    let hash: any = [];
                    let i = 0;

                    $wrapper.querySelectorAll('.js-feature-toggle-value').forEach((element: HTMLElement) => {
                        if (element.classList.contains('feature-toggle-active')) {
                            let dataValue = element.dataset.value;
                            dataValue = dataValue.replace(/'/g, '&#39;');
                            hash[i] = dataValue; // .trim()
                            i++;
                        }
                    });

                    let featureHash = hash.join('|') + '|';
                    let articleId = Object.entries(window['fullFeatureArticleMap'][productId]).find( ([key]) => key === featureHash || key === HtmlEscapeUtils?.escapeHtml(featureHash))?.[1] as string;

                    if (articleId) {
                        updateAccessory(articleId);
                    } else {
                        console.error(`No article found for featureHash: ${featureHash}`);
                    }

                    // if no mapping found, try reverse order
                    // TODO: still needed? Which order is correct?
                    if (typeof articleId === 'undefined' || articleId === '') {
                        const reversed = hash.reverse();

                        featureHash = reversed.join('|') + '|';
                        articleId = window['fullFeatureArticleMap'][productId][featureHash];
                    }

                    if (articleId) {
                        if (typeof $productWrapper !== 'undefined' && $productWrapper) {
                            this.updateArticle(articleId, $productWrapper);
                        } else if(updateSelection === 'slide') {
                            this.updateArticle(articleId, 'slide');
                        } else {
                            this.updateArticle(articleId, 'feature');
                        }
                    }
                } else {
                    console.log('Error: ' + xhr.status); // An error occurred during the request.
                }
            }
        };
    }

    updateArticle(articleId: string, updateSelection: Element | string) {

        if (updateSelection !== 'slide') {
            setTimeout(() => {
                if (this.selectedSlide !== articleId) {
                    this.updateSlide(articleId, updateSelection, 'article', this.currentImage);
                    this.selectedSlide = articleId;
                } else if (this.selectedImage !== this.currentImage) {
                    this.updateSlide(articleId, updateSelection, 'image', this.currentImage);
                    this.selectedImage = this.currentImage;
                }
            }, 50);
        }
        if (this.selectedItem !== articleId || updateSelection === 'url') {
            this.selectedItem = articleId;

            window.fetch(this.param.get('urlPrefix') + '/product/article/' + articleId)
                .then(res => res.json())
                .then((data) => {
                    resetFields;
                    const article = data[0];
                    const viewParams = data[1];
                    this.setFields(viewParams);
                    this.stateChange++;
                    if (article.mainUrl !== null && this.stateChange > 0) {
                        window.history.replaceState('', '', article.mainUrl.originalUrl);
                    }
                    this.refreshContent(article, updateSelection, viewParams);
            }).catch(err => {
                console.log(err);
                this.updateEmptyArticle()
            });
            // update dynamic contents
            window.fetch(this.param.get('urlPrefix') + '/product/article/' + articleId + '/dynamic')
                .then((res) => {
                    if (res.status === 200) {
                        return res.text();
                    }
                })
                .then((data) => {
                    const parsedHTML = document.createRange().createContextualFragment(data);
                    const dynamicContents = Array.from(parsedHTML.querySelectorAll('.dynamic-generic-content'));

                    dynamicContents.forEach(content => {
                        if(document.querySelector('[data-name="' + (<HTMLElement>content).dataset.name + '"]')) {
                            document.querySelector('[data-name="' + (<HTMLElement>content).dataset.name + '"]').replaceWith(content);
                        }
                    })
            }).catch(err => {
                console.log(err);
            });
        }
    }

    parseHTML(str: string) {
      const tmp = document.implementation.createHTMLDocument();
      tmp.body.innerHTML = str;
      return tmp.body.children;
    };

    refreshContent(article: any, updateSelection: Element | string, viewParams: string) {
        let hasFastDelivery = false;

        const articleDescription = document.getElementById('article-description');
        const articleId = document.getElementById('article-id');
        const basketQuantity = (document.getElementById('basket-quantity') as HTMLInputElement);
        const articleStock = document.getElementById('article-stock');
        const articleFeatures = document.getElementById('article-features');
        const articleFeaturePreview = document.getElementById('article-feature-preview');

        const energylabelWrapper:HTMLElement = document.querySelector('.pda-energylabel');
        const energylabelOpen = document.querySelector('.pda-energylabel .energylabel-open');
        const energylabelPdf:HTMLAnchorElement = document.querySelector('.pda-energylabel .energylabel-pdf');
        const energylabelThumb:HTMLImageElement = document.querySelector('.pda-energylabel .energylabel-open img');
        const energylabelVariants = document.getElementById('energylabel-variants');

        if(energylabelVariants && energylabelVariants.getAttribute('data-thumbsrc-' + article.id)) {
            energylabelThumb.src = energylabelVariants.getAttribute('data-thumbsrc-' + article.id);
            energylabelWrapper.style.display = 'flex';

            if(energylabelOpen && energylabelVariants.getAttribute('data-imgsrc-' + article.id)) {
                energylabelOpen.setAttribute('data-imgsrc', energylabelVariants.getAttribute('data-imgsrc-' + article.id));
            }
            if(energylabelOpen && energylabelPdf && energylabelVariants.getAttribute('data-pdfsrc-' + article.id)) {
                energylabelOpen.setAttribute('data-pdfsrc', energylabelVariants.getAttribute('data-pdfsrc-' + article.id));
                energylabelPdf.href = energylabelVariants.getAttribute('data-pdfsrc-' + article.id);
                energylabelPdf.style.display = 'block';
            } else {
                energylabelPdf.style.display = 'none';
            }
        } else {
            energylabelWrapper.style.display = 'none';
        }

        this.articlePrice = document.getElementById('article-price');

        const pda = document.querySelector('.pda');

        const jsPdaQuantity = (document.querySelector('.js-pda-quantity') as HTMLInputElement);

        this.articleTitle.innerHTML = article.shortDescription;
        if (article.description !== '' && 'null' !== article.description && null !== article.description) {
            articleDescription && (articleDescription.innerHTML = article.description);
        }

        articleId && (articleId.innerHTML = article.id);
        articleId && articleId.setAttribute('data-article-id', article.id);
        pda && pda.setAttribute('data-article-id', article.id);

        let design: string = '';
        let perPage: string = '7';
        if(document.querySelector('.pda.pda-v3')) {
            design = 'v3';
            perPage = '7';
        }

        const furnitureRecoElement = document.getElementById('furniture-reco')

        // Update furniture reco if available
        if(furnitureRecoElement) {
            const { height } = furnitureRecoElement.getBoundingClientRect()
            furnitureRecoElement.style.minHeight = `${height}px`

            window.fetch(this.param.get('urlPrefix') + '/mapping/compatible_furniture?articleId=' + article.id + '&tenant=' + this.param.get('tenant') + '&locale=' + this.param.get('clientLocale') + '&minArticlesPerCategory=3&maxArticlesPerCategory=4&minCategories=3')
                .then(res => {
                    if (!res.ok) {
                        throw Error(res.statusText);
                    }
                    return res.text();
                })
                .then((html) => {
                    furnitureRecoElement.innerHTML = html;
                    const recoLoadedEvent = new CustomEvent('recoLoaded', { detail: '.furniture-reco-container' });
                    setTimeout(() => window.dispatchEvent(recoLoadedEvent), 100);
                }).catch(err => {
                console.log(err);
            });
        }
        // Update ordered-together reco if available
        if(document.querySelector('.reco-orderedTogether.v3')) {
            window.fetch(this.param.get('urlPrefix') + '/mapping/new/reco?key=' + this.param.get('productId') + '&reco=cross-seller&maxRecos=3&msg=ssh.product.reco.orderedTogether&slidesPerView=5&cssClass=crossseller-container&fallbacks=item-based&recos=v2&showCheckbox=true&articleToAdd=' + article.id + '&layout=orderedTogether&minRecos=2')
                .then(res => {
                    if (!res.ok) {
                        throw Error(res.statusText);
                    }
                    return res.text();
                })
                .then((html) => {
                    document.querySelector('.orderedTogether-wrapper').innerHTML = html;

                    const ot = new OrderedTogether;
                    ot.handleCheckboxes(document.querySelector('.reco-orderedTogether.v3'));
                    ot.handleAddToCart(document.querySelector('.reco-orderedTogether.v3'));
                }).catch(err => {
                console.log(err);
            });
        }

        getPrice(article.id, 1, '', design).then((articlePriceSnippet: any) => {
            if (articlePriceSnippet && articlePriceSnippet.toString().includes('<script')) {
                var Globaleval = (code: string) => {
                    let script = document.createElement('script');
                    script.text = code;

                    document.head.appendChild(script).parentNode.removeChild(script);
                };

                const snippet = (this.parseHTML(articlePriceSnippet.toString()) as NodeList | any);

                snippet.forEach((el: Element) => {
                    const script = el.querySelector('script');
                    script && Globaleval(script.innerText);
                });
            }
            let resultsScaledPrice = document.querySelector('.results-scaledprice');
            resultsScaledPrice && resultsScaledPrice.parentNode.removeChild(resultsScaledPrice);
            this.articlePrice && (this.articlePrice.innerHTML = articlePriceSnippet);

            const pdaStickyCta = document.querySelector('.pda-sticky-cta');
            const prcArticle = document.querySelector('.prc-article');
            if (pdaStickyCta && prcArticle) {
                document.querySelector('.pda-sticky-title h3').innerHTML = this.articleTitle.innerHTML;
                const prcStickyOffer = pdaStickyCta.querySelector('.prc-article-offer');
                const prcOffer = this.articlePrice.querySelector('.prc-offer');
                prcStickyOffer && (prcStickyOffer.innerHTML = prcOffer && prcOffer.innerHTML);
                pdaStickyCta.querySelector('.prc-article-unit').innerHTML = document.querySelector('.prc-article .prc-list-info').innerHTML;
                const prdImage = document.querySelector('#pda-gallery-hero [data-article-id="' + article.id + '"]');
                document.querySelector('.pda-sticky-cta-box .article-name picture').innerHTML = (prdImage && prdImage.innerHTML);

                const stickyPriceBasePrice = document.querySelector('.pda-sticky-cta .prc-baseprice');
                const PriceBasePrice = document.querySelector('.pda-cta-price .prc-baseprice');
                PriceBasePrice && stickyPriceBasePrice && (stickyPriceBasePrice.innerHTML = PriceBasePrice.textContent);

                resizeGallery()
            }
            resultsScaledPrice = document.querySelector('.results-scaledprice');
            const pdaCtaBox = document.querySelector('.pda-cta-box') as HTMLElement;
            if (resultsScaledPrice) {
                if(document.querySelector('.pda.pda-v3') && document.querySelector('.best-prc-wrapper') ) {
                    document.querySelector('.best-prc-wrapper').appendChild(resultsScaledPrice);
                    (<HTMLElement>document.querySelector('.results-scaledprice')).style.maxHeight = (<HTMLElement>document.querySelector('.result-bulk')).offsetHeight + 'px';

                    document.querySelector('.toggle-bestprice-table').addEventListener('click', function() {
                        if(this.classList.contains('active')) {
                            this.classList.remove('active');
                            (<HTMLElement>document.querySelector('.results-scaledprice')).style.maxHeight = '0';
                        } else {
                            this.classList.add('active');
                            (<HTMLElement>document.querySelector('.results-scaledprice')).style.maxHeight = (<HTMLElement>document.querySelector('.result-bulk')).offsetHeight + 'px';
                        }

                    });
                } else {
                    pdaCtaBox.appendChild(resultsScaledPrice);
                }
            }
            shipmentTooltip();
        }).catch((err) => {
            console.log(err);
            this.updateEmptyArticle()
        });

        if (article.stock && typeof article.stock !== 'undefined' && typeof article.stock.deliveyPeriodText !== 'undefined') {
            const deliveryText = document.querySelector('#available .article-delivery-time');
            deliveryText && (deliveryText.innerHTML = article.stock.deliveyPeriodText);
        }

        const stockInfo = document.querySelector('#article-stock .stock-info');
        if (article.stock && typeof article.status !== 'undefined' && typeof article.status.remainderOfStockText !== 'undefined' && article.status.remainderOfStockText !== null) {
            stockInfo && (stockInfo.innerHTML = article.status.remainderOfStockText);
            articleStock && (articleStock.style.display = 'block');
            basketQuantity && basketQuantity.setAttribute('max', article.status.stock);
            if (article.status.stock === 1) {
                traversal.siblings(basketQuantity.parentElement, '.incrementer-inc').forEach((inc) => {
                    inc.classList.add('incrementer-inactive');
                });

                traversal.siblings(jsPdaQuantity.parentElement, '.incrementer-inc').forEach((inc) => {
                    inc.classList.add('incrementer-inactive');
                });
            }
            updateInc('1', article.status.stock);
        } else {
            stockInfo && (stockInfo.innerHTML = '');
            articleStock && (articleStock.style.display = 'none');
            basketQuantity && basketQuantity.setAttribute('max', '99999');
            updateInc('1', '99999');
        }

        resetFields();
        this.setFields(viewParams);
        updatePriceListName();

        if (this.param.get('showPromotionDesigner') === 'true'
            && this.param.get('showBasket') === 'true'
            && this.param.get('productConfigurable') === 'true'
            && this.param.get('articlePrintPrices') === 'true') {
            this.updatePrintPrice(article.id);
        }

        // KeyFacts
        articleFeatures && (articleFeatures.innerHTML = '');
        article.features.forEach((el: any) => {
            if (el.inTechData === true) {
                articleFeatures && (articleFeatures.innerHTML += '<li><span class="list-label">' + el.name + '</span><span class="list-field">' + el.value + '</span></li>');
            }
            if (el.id === 'MAN1000') {
                hasFastDelivery = true;
            }
        });

        const productItemFastBadge = (document.querySelector('.product-item-fast-badge') as HTMLElement);

        if (hasFastDelivery) {
            productItemFastBadge && (productItemFastBadge.style.display = 'block');
        } else {
            productItemFastBadge && (productItemFastBadge.style.display = 'none');
        }

        // Preview Block
        // If Benefit exist, hide everything else
        let hasPreview = false;

        if (article.benefit !== null && article.benefit !== '' && typeof article.benefit !== 'undefined') {
            document.querySelectorAll('.pda-preview-benefits h4').forEach((el: HTMLElement) => el.style.display = 'block');
            document.querySelectorAll('.js-pda-preview-benefits').forEach((el: HTMLElement) => el.innerHTML = '');
            document.querySelectorAll('.pda-preview-description').forEach((el: HTMLElement) => el.style.display = 'none');
            document.querySelectorAll('.technical-data-fade-out').forEach((el: HTMLElement) => el.style.display = 'none');
            articleFeaturePreview && (articleFeaturePreview.innerHTML = '');
            hasPreview = true;
            document.querySelectorAll('.js-pda-preview-benefits').forEach((el: HTMLElement) => el.innerHTML = article.benefit);
        }
        // If Benefit does not exist, check if vea-features exist
        if (hasPreview === false) {
            document.querySelectorAll('.pda-preview-benefits h4').forEach((el: HTMLElement) => el.style.display = 'none');
            document.querySelectorAll('.js-pda-preview-benefits').forEach((el: HTMLElement) => el.innerHTML = '');
            document.querySelectorAll('.js-product-preview-desc').forEach((el: HTMLElement) => el.style.display = 'none');
            document.querySelectorAll('.technical-data-fade-out').forEach((el: HTMLElement) => el.style.display = 'block');
            articleFeaturePreview && (articleFeaturePreview.innerHTML = '');
            article.features.forEach((el: any) => {
                if (el.vea === true && el.value !== 'undefined') {
                    articleFeaturePreview && (articleFeaturePreview.innerHTML += '<li><span class="list-label">' + el.name + '</span><span class="list-field">' + el.value + '</span></li>');
                    hasPreview = true;
                }
            });
        }
        // Fallback to init description
        if (hasPreview === false) {
            document.querySelectorAll('.pda-preview-benefits h4').forEach((el: HTMLElement) => el.style.display = 'none');
            document.querySelectorAll('.pda-preview-description').forEach((el: HTMLElement) => el.style.display = 'block');
            document.querySelectorAll('.technical-data-fade-out').forEach((el: HTMLElement) => el.style.display = 'none');
        }


        if (updateSelection === 'slide' || updateSelection === 'url') {
            Object.entries(window['articleFeatureMap'][article.id]).forEach((entry) => {
                const key: string = entry[0];
                const value: any = entry[1];
                const inputFeature = (document.querySelector('#input-feature-' + key) as HTMLInputElement);
                if (inputFeature) {
                    inputFeature.value = value;
                    const selectedInputFeature = document.querySelector('[data-feature-selected="input-feature-' + key + '"]');
                    selectedInputFeature && (selectedInputFeature.innerHTML = value);
                }
            });
        }

        const slideContent = document.querySelector('#pda-gallery-hero .splide__slide[data-article-id="' + article.id + '"]');

        document.querySelector('.modal-product-title').innerHTML = this.articleTitle.innerHTML;
        document.querySelector('.modal-product-id').innerHTML = articleId.getAttribute('data-article-id');
        document.querySelector('.modal-product-price').innerHTML = this.articlePrice && this.articlePrice.innerHTML;
        document.querySelector('.modal-product-image').innerHTML = slideContent && slideContent.innerHTML;

        document.querySelectorAll('.cmp-swiper-pda-thumbnails .cmp-swiper-slide').forEach((el: HTMLElement) => el.classList.remove('cmp-swiper-slide-active'));
        const setCmpSwiperSlide = document.querySelector('.cmp-swiper-pda-thumbnails .cmp-swiper-slide[data-article-id="' + article.id + '"]');
        setCmpSwiperSlide && setCmpSwiperSlide.classList.add('cmp-swiper-slide-active');
    }

    updateSlide(articleId: string, updateSelection: Element | string, indexType: string, currentImage: string) {

        const oldSlides = [].slice.call(document.querySelectorAll('#pda-gallery-hero .splide__slide'));
        oldSlides.forEach(function (slide:HTMLElement) {
            document.querySelector('#gallery-storage ul.main-slides').appendChild(slide);
        })

        const mainSlidesToShow = [].slice.call(document.querySelectorAll('#gallery-storage ul.main-slides [data-article-id="'+articleId+'"], #gallery-storage ul.main-slides [data-gallery="alwaysshown"]'));
        const thumbSlidesToShow = [].slice.call(document.querySelectorAll('#gallery-storage ul.thumb-slides [data-article-id="'+articleId+'"], #gallery-storage ul.thumb-slides [data-gallery="alwaysshown"]'));

        document.querySelector('#pda-gallery-thumbnails').innerHTML = '';

        mainSlidesToShow.forEach(function (slide:HTMLElement) {
            (<any>window).sl1.add(slide);
        });

        (<any>window).sl1.refresh();

        let thumbs:Array<HTMLElement> = [];
        thumbSlidesToShow.forEach(function (slide:HTMLElement, index:number) {
            if(thumbSlidesToShow.length <= 1) {
                (<HTMLElement>document.querySelector('#pda-gallery-thumbnails')).style.display = 'none';
                (<HTMLElement>document.querySelector('#pda-gallery-hero')).classList.add('no-border');
            } else {
                if(window.innerWidth >= 992) {
                    (<HTMLElement>document.querySelector('#pda-gallery-thumbnails')).style.display = 'flex';
                    (<HTMLElement>document.querySelector('#pda-gallery-hero')).classList.remove('no-border');
                }
            }
            const clone = <HTMLElement>slide.cloneNode(true);
            clone.dataset.index = index.toString();
            clone.setAttribute('tabindex', "0");
            thumbs.push(clone);
            document.querySelector('#pda-gallery-thumbnails').appendChild(clone);
        });

        (<any>window).sl1.go(0);

        thumbs.forEach(function (thumb:HTMLElement, index:any) {
            if(index == 0) {
                thumb.classList.add('active');
            }

            thumb.addEventListener('click', function () {
                thumbs.forEach(function (thumb:HTMLElement) {
                    thumb.classList.remove('active');
                })
                thumb.classList.add('active');

                var i = parseInt(this.dataset.index);
                (<any>window).sl1.go(i);
            })
        })

        if(document.querySelector('.modal-product-image img')) {
            document.querySelectorAll('.modal-product-image img')[0].setAttribute('src', mainSlidesToShow[0].querySelector('img').getAttribute('src'));
        }


        return false;
    }

    setFields(viewParams: Promise<object> | any) {
        this.soldOut = document.getElementById('sold_out');
        this.soldOutMsg = document.getElementById('sold-out-msg');
        this.not_Available = document.getElementById('not_available');
        this.notAvailableMsg = document.getElementById('not-available-msg');
        this.available = document.getElementById('available');
        this.quantity = document.getElementById('quantity');
        this.basketEnabled = document.getElementById('basket-enabled');
        this.basketDisabled = document.getElementById('basket-disabled');
        this.basketReminder = document.getElementById('basket-reminder');
        this.stickyBasketCta = document.getElementById('sticky-basket-cta');
        this.stickyBasketCtaBox = document.querySelector('.pda-sticky-cta-box');
        this.pdaCtaButtons = document.querySelector('.pda-cta-buttons');

        let notAvailable = false;

        if (viewParams.showSoldout) {
            this.soldOut && this.soldOut.classList.remove('hidden');
            this.soldOutMsg && this.soldOutMsg.classList.remove('hidden');
            notAvailable = true;
        }

        if (viewParams.showTmpNotAvailable) {
            this.not_Available && this.not_Available.classList.remove('hidden');
            this.notAvailableMsg && this.notAvailableMsg.classList.remove('hidden');
            const allNotAvailable = document.querySelector('#all_not_available');
            allNotAvailable && allNotAvailable.classList.add('hidden');
            this.basketReminder && this.basketReminder.classList.remove('hidden');
            if(this.stickyBasketCtaBox) (<HTMLElement>this.stickyBasketCtaBox).classList.add('hidden');
            if(this.basketReminder) {
                this.basketDisabled && this.basketDisabled.classList.add('hidden');
                this.pdaCtaButtons && this.pdaCtaButtons.classList.add('hidden');
            }

            const basketReminder = <HTMLButtonElement>document.getElementById('basket-reminder');
            let articleId = document.querySelectorAll('.pda')[0].getAttribute('data-article-id');
            if(basketReminder && !basketReminder.classList.contains('hidden')) getReminder(basketReminder, articleId);

            notAvailable = true;
        } else {
            if(this.stickyBasketCtaBox) (<HTMLElement>this.stickyBasketCtaBox).classList.remove('hidden');
            if(this.basketReminder) {
                this.basketReminder && this.basketReminder.classList.add('hidden');
                this.pdaCtaButtons && this.pdaCtaButtons.classList.remove('hidden');
            }
        }

        if (notAvailable === false) {
            this.available && this.available.classList.remove('hidden');
        }

        if (viewParams.showQuantity) {
            this.quantity && this.quantity.classList.remove('hidden');
        }

        if (viewParams.showBasket) {
            this.basketEnabled && this.basketEnabled.classList.remove('hidden');
            enableButton((this.basketEnabled as HTMLButtonElement));

            this.stickyBasketCta && this.stickyBasketCta.classList.remove('cta-inactive');
            this.stickyBasketCta && this.stickyBasketCta.classList.add('cta-primary');
        } else {
            this.basketDisabled && this.basketDisabled.classList.remove('hidden');

            this.stickyBasketCta && this.stickyBasketCta.classList.remove('cta-primary');
            this.stickyBasketCta && this.stickyBasketCta.classList.add('cta-inactive');
        }

        if (viewParams.showTodolist) {
            const wishlistButton = document.querySelector('.toggle-wishlist');
            wishlistButton && wishlistButton.setAttribute('disabled', 'disabled');
        }
    }

    updatePrintPrice(id: string) {
        const articlePrintPriceClass = document.querySelector('.article-printPrice');
        articlePrintPriceClass && ((articlePrintPriceClass as HTMLElement).style.display = 'none');
        const articlePrintPrice = document.getElementById('article-printPrice-' + id);
        articlePrintPrice && ((articlePrintPrice as HTMLElement).style.display = 'block');
    }

    updateEmptyArticle() {
        resetFields();

        this.not_Available && this.not_Available.classList.remove('hidden');
        this.notAvailableMsg && this.notAvailableMsg.classList.remove('hidden');
        this.basketDisabled && this.basketDisabled.classList.remove('hidden');
        const todoListDisabled = document.getElementById('todo-list-disabled');
        todoListDisabled && todoListDisabled.classList.remove('hidden');
        this.articleTitle && (this.articleTitle.innerHTML = this.param.get('urlName'));
        const articleId = document.getElementById('article-id');
        articleId && (articleId.innerHTML = '');
        articleId && articleId.setAttribute('data-article-id', '');
    }

    initToggleTooltip() {
        // show tooltip for disabled toggle
        this.featureToggles.forEach(feature => {
            const height: number = feature.clientHeight;
            if (height <= this.maxHeight) {
                let disabledToggles = feature.querySelectorAll('.js-feature-toggle-value');
                if (typeof disabledToggles !== 'undefined') {
                    disabledToggles.forEach((toggle: HTMLElement) => {
                        if (!toggle.classList.contains('hidden')) {
                            const tooltipText = traversal.parents(toggle, '.feature-toggle-wrapper')[0].querySelectorAll('.feature-toggle-disabled-hint-text')[0].textContent;

                            let newcontent = document.createElement('span');
                            newcontent.className = 'feature-toggle-disabled-hint';
                            newcontent.innerHTML = tooltipText;
                            toggle.appendChild(newcontent);
                        }
                    });
                }
            }
        });
    }

    showComparison() {
        window.fetch(this.param.get('urlPrefix') + '/mapping/new/product-comparison?productId=' + this.param.get('productId') + '&categoryId=' + this.param.get('category'))
                .then(res => {
                    if (!res.ok) {
                        throw Error(res.statusText);
                    }
                    return res.text()
                })
                .then((html) => {
                    const jsPdaComparison = document.querySelector('.js-pda-comparison');
                    jsPdaComparison && (jsPdaComparison.innerHTML = html);

                    const expander = document.getElementById('product-compare-expander');

                    if (expander) {
                        let expanderButton = document.getElementById('expander-button'),
                            table = document.getElementById('product-compare'),
                            tableHeight = table.offsetHeight,
                            startHeight = 700,
                            heightIncrement = 400;

                        if (startHeight > tableHeight) {
                            expanderButton.style.opacity = '0';
                            expanderButton.style.pointerEvents = 'none';
                            expander.style.maxHeight = tableHeight + 'px';
                        } else {
                            expander.style.maxHeight = startHeight + 'px';
                        }

                        window.addEventListener('resize', () => {
                            tableHeight = table.offsetHeight;

                            if (startHeight < tableHeight) {
                                expanderButton.style.opacity = '1';
                                expanderButton.style.pointerEvents = 'all';
                            }
                        });

                        expanderButton.addEventListener('click', () => {
                            if (startHeight < tableHeight) {
                                if (startHeight + heightIncrement < tableHeight) {
                                    startHeight += heightIncrement;
                                } else {
                                    startHeight = tableHeight;
                                    expanderButton.style.opacity = '0';
                                    expanderButton.style.pointerEvents = 'none';
                                }
                                expander.style.maxHeight = startHeight + 'px';
                            }
                        });

                        addEnterAndSpaceHandler();

                    }
            }).catch(err => {
                console.log(err);
            });
    }

    updateFeatureToggleSelection(featureMap: any) {
        let lastActiveElement: HTMLElement;

        Object.entries(featureMap).forEach((entry) => {
            const key: string = entry[0];
            const value: any = entry[1];
            const featureToggleWrapper = document.querySelector('.feature-toggle-wrapper #feature-' + key);

            if (featureToggleWrapper) {
                featureToggleWrapper.querySelectorAll('.js-feature-toggle-value').forEach(el => el.classList.remove('feature-toggle-active'));
                lastActiveElement = featureToggleWrapper.querySelector('[data-value="' + value + '"]');
                lastActiveElement.classList.add('feature-toggle-active');
            }
        });

        if (featureMap && Object.keys(featureMap).length !== 0) {
            this.processingUpdate(lastActiveElement, 'select', 'slide')
        }
    }

    init() {
        this.dropdownToggle();
        this.initToggleListener();
        this.initToggleTooltip();

        if (this.param.get('showPromotionDesigner') === 'true'
          && this.param.get('showBasket') === 'true'
          && this.param.get('productConfigurable') === 'true'
          && this.param.get('articlePrintPrices') === 'true') {
          this.updatePrintPrice(this.selectedItem);
        }

        if (this.param.get('category')) {
          this.showComparison();
          new SimilarProducts().init();
        }

        installationTooltip();
        shipmentTooltip();
    }
}
